import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('audit-reports');

export const auditReportsApiClient = axiosClient;

export default axiosClient;
